"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IcatuPensionStatus = void 0;
var IcatuPensionStatus;
(function (IcatuPensionStatus) {
    IcatuPensionStatus["Active"] = "ATIVO";
    IcatuPensionStatus["Blocked"] = "BLOQUEADO";
    IcatuPensionStatus["Canceled"] = "CANCELADO";
    IcatuPensionStatus["BenefitConcession"] = "EM CONCESS\u00C3O DE BENEF\u00CDCIO";
})(IcatuPensionStatus = exports.IcatuPensionStatus || (exports.IcatuPensionStatus = {}));
//# sourceMappingURL=IcatuPensionStatus.js.map